import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import ErrorBoundary from 'shared/ErrorBoundary';
import AddToCustomerProfile from './AddToCustomerProfile';
import { AddNewSequence } from './components/AddNewSequence';
import TopBar from './components/TopBar';
import ProfilePage from './ProfilePage';
import SomethingWentWrong from './SomethingWentWrong';

export default function Extension({ data }) {
  return (
    <ErrorBoundary FallbackComponent={SomethingWentWrong}>
      <Router>
        <Switch>
          <Route exact path="/amplemarket_hook">
            <TopBar display>
              <ProfilePage isEmailReplySequence />
            </TopBar>
          </Route>
          <Route exact path="/zendesk_sell/lead_card">
            <TopBar display>
              <ProfilePage onSubmitPath="zendesk_sell/lead_card" isZendeskSell />
            </TopBar>
          </Route>
          {/* routes below can be fully removed once routes above are moved to spa-root router */}
          <Route path="/add_list">
            <AddToCustomerProfile />
          </Route>
          <Route path="/add_new_sequence">
            <AddNewSequence data={data} />
          </Route>
        </Switch>
      </Router>
    </ErrorBoundary>
  );
}
